<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">Actividad de usuarios</h2>
    <MainUsersActivityReport />
  </div>
</template>

<script>
import { onBeforeMount, onMounted } from "vue";
import { useRoute } from "vue-router";
import { findSubmoduleIdByDescription } from "@/hisAcces";
import MainUsersActivityReport from "@/components/Reports/UsersActivity/MainUsersActivityReport.vue";

export default {
  name: "UsersActivityReport",
  components: {
    MainUsersActivityReport,
  },
  setup() {
    const route = useRoute();

    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE || process.env.VUE_APP_TITLE;
    });
  },
};
</script>